import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { putUser } from "../../actions/user";
import { useEffect } from "react";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Switch from "@mui/material/Switch";
import { Grid, Input, MenuItem, Select, InputLabel } from "@mui/material";
import { Divider, Button } from "@mui/material";
import CountrySelect from "../../CountrySelect";
import md5 from "md5";
import { toast } from "react-toastify";
import { gridDensityHeaderGroupingMaxDepthSelector } from "@mui/x-data-grid";
import { getCenters } from "../../actions/center";
import { getAgencies } from "../../actions/agency";
import UserModalForm from "./UserModalForm";

const UserModal = (props) => {

  const [TitleType, setTitleType] = useState("Type");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [address_one, setAddressOne] = useState("");
  const [address_two, setAddressTwo] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");
  const [locality, setLocality] = useState("");
  const [country, setCountry] = useState("");
  const [type, setType] = useState(0);
  const [active, setActive] = useState(true);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [id_center, set_id_center] = useState(null);
  const [id_agency, set_id_agency] = useState(null);

  const { message, setMessage } = useSelector((state) => state.message);
  const { user: connectedUser } = useSelector((state) => state.auth);

  const { users: listUsers } = useSelector((state) => state.users);
  const { centers: listCenters } = useSelector((state) => state.centers);
  const { agencies: listAgencies } = useSelector((state) => state.agencies);



  const dispatch = useDispatch();

  const clearUI = () => {
    setTitleType("");
    setEmail("");
    setFirstName("");
    setLastName("");
    setPhoneNumber("");
    setPassword("");
    setPassword2("");
    setAddressOne("");
    setAddressTwo("");
    setZipCode("");
    setLocality("");
    setCountry("");
    setActive(true);
    setType(0);
  };

  useEffect(() => {

    if (!listCenters) dispatch(getCenters());
    if (!listAgencies) dispatch(getAgencies());

    if (props.show && props.currentUser != null && !loaded) {
      const filtered = listUsers.filter((user) => {
        return user.id === props.currentUser.id;
      });

      filtered.map(
        (user) => (
          setEmail(user.email),
          setFirstName(user.firstName),
          setLastName(user.lastName),
          setPhoneNumber(user.phoneNumber),
          setPassword(""),
          setPassword2(""),
          setAddressOne(user.adress),
          setAddressTwo(user.adress2),
          setZipCode(user.zipcode),
          setLocality(user.locality),
          setCountry(user.country),
          setActive(user.active),
          setType(user.type),
          set_id_agency(user.idAgency),
          set_id_center(user.idCenter)
        )
      );
      setLoaded(true);
    }

    if (!props.show && props.currentUser) {
      clearUI();
      setLoaded(false);
    }
  });

  const onHide = () => {
    clearUI();
    props.onHide();
  }

  const handleSubmit = (e) => {

    if (props.currentUser == null && password != password2) {
      toast.error(
        `Passwords don't match.`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
      );
      return;
    }

    e.preventDefault();

    setLoading(true);
    let user_tmp = {};

    if (props.currentUser != null) {
      user_tmp = props.currentUser;
    } else {
      user_tmp.id = 0;
    }

    user_tmp.password = (password != "" && password2 != "") ? md5(password) : props.currentUser.password

    user_tmp.lastName = lastname;
    user_tmp.firstName = firstname;
    user_tmp.active = active;
    user_tmp.adress = address_one;
    user_tmp.adress2 = address_two;
    user_tmp.country = country;
    user_tmp.email = email;
    user_tmp.locality = locality;
    user_tmp.phoneNumber = phonenumber;
    user_tmp.zipcode = zip_code;

    if (connectedUser.idAgency > 0)
    {
      user_tmp.idAgency = connectedUser.idAgency;
      user_tmp.type = 4;
    }
    else
    {
      user_tmp.type = type;
      user_tmp.idAgency = id_agency;
    }
    
    user_tmp.idCenter = id_center;
    user_tmp.agencyName = id_agency > 0 ? listAgencies.filter((a) => a.id == id_agency)[0].name : null
    user_tmp.centerName = id_center > 0 ? listCenters.filter((c) => c.id == id_center)[0].name : null

    if (connectedUser.id === user_tmp.id) {
      connectedUser.lastName = user_tmp.lastName;
      connectedUser.firstName = user_tmp.firstName;
    }

    dispatch(putUser(user_tmp))
      .then(() => {
        toast.success(
          `User ${user_tmp.id > 0 ? "updated" : "created"} successfuly`,
          { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
        setLoading(false);
      })
      .catch(() => {
        toast.error(
          `An Error occured while ${user_tmp.id > 0 ? "updating" : "creating"} the user. Try again later.`,
          { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
        setLoading(false);
      });

    props.onHide();

  };

  return (
    <Modal {...props} size="lg" centered>
      <UserModalForm
        isModal={true}
        setActive={setActive} active={active}
        setFirstName={setFirstName} firstname={firstname}
        setLastName={setLastName} lastname={lastname}
        setType={setType} type={type}
        set_id_agency={set_id_agency} id_agency={id_agency}
        set_id_center={set_id_center} id_center={id_center}
        setAddressOne={setAddressOne} address_one={address_one}
        setAddressTwo={setAddressTwo} address_two={address_two}
        setZipCode={setZipCode} zipcode={zip_code}
        setLocality={setLocality} locality={locality}
        setCountry={setCountry} country={country}
        setEmail={setEmail} email={email}
        setPhoneNumber={setPhoneNumber} phonenumber={phonenumber}
        setPassword={setPassword} password={password}
        setPassword2={setPassword2} password2={password2}
        handleSubmit={handleSubmit}
        listAgencies={listAgencies}
        listCenters={listCenters}
        onHide={onHide}
        currentUser={props.currentUser} />
    </Modal>
  );
};

export default UserModal;
